import { Box, Grid, Typography } from "@mui/material";

import LottieAnimation from "components/LottieAnimation";

export interface ImagePlaceholderProps {
  action?: React.ReactNode;
  animationData: any;
  text: string;
  width?: number | string;
}

function AnimatedPlaceholder(props: ImagePlaceholderProps) {
  const { action, animationData, text, width = "100%" } = props;

  return (
    <Grid
      alignItems='center'
      container
      direction='column'
      padding={4}
      position='absolute'
      top='50%'
      width='100%'
      sx={{ transform: "translateY(-50%)" }}
    >
      <Grid display='flex' justifyContent='center' item>
        <Box width={width} mb={4} sx={{ maxWidth: { sm: "25rem" } }}>
          <LottieAnimation animationData={animationData} loop />
        </Box>
      </Grid>
      <Grid item>
        <Typography align='center' color='textSecondary'>
          {text}
        </Typography>
      </Grid>
      {action ? (
        <Grid item mt={4}>
          {action}
        </Grid>
      ) : null}
    </Grid>
  );
}

export default AnimatedPlaceholder;
